import React from 'react';
import { capitalizeFirstLetter } from '../../util/helperFunctions';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import { Section } from 'bloomer/lib/layout/Section';
import { Button } from 'bloomer/lib/elements/Button';
import ReactTable from 'react-table';
import styled from 'styled-components';

const FlexBox = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
`;
export default class IndividualDogBreakdown extends React.Component {
	constructor() {
		super();
		this.state = {
			animalSort: 'all animal'
		};
		this.applyFilter = this.applyFilter.bind(this);
	}

	getColumns = (average) => {
		const typeColumns = this.props.enrichmentTypes.map(type => ({
			Header: type,
			accessor: (row) => row[type] ? (average ? (row[type] / row.days.length).toFixed(1) : row[type]) : 0,
			Cell: ({ value }) => <p className="has-text-centered">{value}</p>,
			id: `${type}-${average ? "average" : 'total'}`
	}))

	return [
		{
			Header: 'A#',
			accessor: 'aNumber',
			Cell: ({ value }) => <p className="has-text-centered">{value}</p>,
			id: `anumber-${average ? "average" : 'total'}`
		},
		...typeColumns
	]
	}

	applyFilter(entry) {
		let filter = this.state.animalSort;

		if (filter === 'all animal') {
			return true;
		} else if (filter === 'longstay animal') {
			return entry.longStayStartTracking;
		} else if (filter === 'animals with training plans') {
			return entry.trainingPlan !== 'no' && Boolean(entry.trainingPlan);
		}
	}

	render() {
		const { animalDataSums, animalType } = this.props;
		const animalsSorted = animalDataSums.filter(this.applyFilter);
		return (
			<Box className="on-print-own-page">
				<Title tag="h3">Individual {capitalizeFirstLetter(animalType)} Information:</Title>
				<FlexBox>
						<Button
							isColor="primary"
							onClick={() => {
								this.setState({ animalSort: 'all animal' });
							}}
						>
							All {animalType}s
						</Button>
						<Button
							isColor="primary"
							onClick={() => {
								this.setState({ animalSort: 'longstay animal' });
							}}
						>
							Long Stay
						</Button>
						<Button
							isColor="primary"
							onClick={() => {
								this.setState({ animalSort: 'animals with training plans' });
							}}
						>
							Behaviour {animalType}s
						</Button>
					</FlexBox>
				<Section>
					<Title className="is-capitalized" tag="h4">{`${this.state.animalSort} Totals`}</Title>
					<ReactTable 
							data={animalsSorted}
							columns={this.getColumns(false)}
					/>
				</Section>
				<Section>
				<Title className="is-capitalized" tag="h4">{`${this.state.animalSort} Daily Averages`}</Title>
					<ReactTable 
							data={animalsSorted}
							columns={this.getColumns(true)}
					/>
				</Section>
			</Box>
		);
	}
}
